import React, { memo } from "react";
import {
  VisualizationBottomRowContainer,
  VisualizationHandlesContainer,
} from "../VizGrid";

interface LegendRowProps {
  children: React.ReactNode;
}

const LegendRow = memo(({ children }: LegendRowProps) => (
  <VisualizationBottomRowContainer>
    <VisualizationHandlesContainer>{children}</VisualizationHandlesContainer>
  </VisualizationBottomRowContainer>
));

LegendRow.displayName = "LegendRow";

export default LegendRow;
